export default __webpack_public_path__ + "static/media/icon_tranfers.44add824.svg";